export function formattedPriceUtils(price, currencyCode = '', convert = true) {
    const exchangeRate = 1.95583; // Fixed BGN to EUR rate

    const symbols = {
        EUR: '€',
        BGN: 'лв.',
    };

    let convertedPrice = parseFloat(price);

    // Ensure conversion only when the target currency is specified
    if (currencyCode === 'EUR' && convert) {
        convertedPrice = convertedPrice / exchangeRate;
    } else if (currencyCode === 'BGN' && convert) {
        convertedPrice = convertedPrice * exchangeRate;
    }

    // Format to two decimal places
    const formatted = convertedPrice.toFixed(2);
    const [whole, decimal] = formatted.split('.');

    const symbol = symbols[currencyCode] || currencyCode;

    return `${whole}<sup class="coins" style="vertical-align: unset!important;"><small class="decimal">.</small>${decimal}</sup> ${symbol}`;
}